import { FundTagIcon } from '../../core/themes/icons/FundTagIcon';
import FundTagCreate from './FundTagCreate';
import FundTagEdit from './FundTagEdit';
import FundTagList from './FundTagList';

export default {
  list: FundTagList,
  create: FundTagCreate,
  edit: FundTagEdit,
  icon: FundTagIcon
};
